import React, { useState } from "react";
import Select from "react-select";
import { centerOptions, doctorOptions, doctorsWithId } from "../contants/options";
import * as XLSX from 'xlsx';
import DoctorTables from "../tables/DoctorTables";
import OpdTables from "../tables/OpdTables";
import exportIcon from "../assets/export.svg";
import searchIcon from "../assets/searchicon.svg";

const OpdPayout = () => {
    const [filters, setFilters] = useState({
        centers: [],
        doctors: [],
        startDate: "",
        endDate: "",

    });

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    // Simulated API call
    const fetchData = async () => {
        setIsLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/doctor-transaction-over-range`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                billingDoctorIds: filters?.doctors?.map((doctor) => doctor.value).length > 0 ? filters?.doctors?.map((doctor) => doctor.value) : null,
                locationIds: filters?.centers?.map((center) => center.value).length > 0 ? filters?.centers?.map((center) => center.value) : null,
                startDate: filters?.startDate,
                endDate: filters?.endDate

            })

        });



        const result = await response.json();
        setData(result);
        // setCurrentPage(1)
        setIsLoading(false);

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };


    const handleExport = () => {
        setIsLoading(true);

        // Format the data to match table columns
        const exportData = data?.map(item => ({
            'Doctor Name': item.DoctorName,
            'Center': item.location,
            'Charged Amount': item.charged + item.discount,
            'Discount': item.discount,
            'Collected': item.collected,
            'Pending': item.charged - item.collected
        })) || [];

        // Calculate totals
        const totals = data?.reduce((acc, curr) => ({
            charged: (acc.charged || 0) + (curr.charged + curr.discount),
            discount: (acc.discount || 0) + curr.discount,
            collected: (acc.collected || 0) + curr.collected,
            balance: (acc.balance || 0) + (curr.charged - curr.collected)
        }), {});

        // Add totals row
        if (totals) {
            exportData.push({
                'Doctor Name': 'TOTAL',
                'Center': '',
                'Charged Amount': totals.charged,
                'Discount': totals.discount,
                'Collected': totals.collected,
                'Pending': totals.balance
            });
        }

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);

        // Function to calculate auto column widths based on content
        const getColumnWidths = (data) => {
            if (!data.length) return [];
            return Object.keys(data[0]).map((key) => ({
                wch: Math.max(
                    key.length, // Header length
                    ...data.map(row => (row[key] ? row[key].toString().length : 0)) // Max content length
                ) + 2 // Add padding
            }));
        };

        // Set auto-adjusting column widths
        ws['!cols'] = getColumnWidths(exportData);

        // Create workbook and add worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Doctor Payouts');

        // Generate filename with current date
        const filename = `OPD_${filters.doctors.map((doctor) => doctor.label).join(',')}_${filters.startDate}_To_${filters.endDate}_summary.xlsx`;

        // Write file
        XLSX.writeFile(wb, filename);
        setIsLoading(false);
    };


    const handleChange = (selectedOptions) => {
        setFilters((prev) => ({ ...prev, doctors: selectedOptions }));
    };

    return (
        <>
            <div
                style={{ padding: "20px", display: "flex", flexDirection: "column" }}
            >
                <h2
                    style={{
                        fontSize: "24px", // Adjust font size
                        fontWeight: "bold", // Bold font weight
                        color: "#2D3748", // Dark gray color for text
                        textAlign: "center", // Center align text
                        marginBottom: "20px", // Space below the header
                        letterSpacing: "1px", // Slightly increase letter spacing
                        textTransform: "uppercase", // Capitalize the text
                        borderBottom: "3px solid #4A90E2", // Add an underline with color
                        paddingBottom: "10px", // Padding below the text to separate it from the line
                    }}
                >
                    OPD Doctor Payout
                </h2>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.2fr", // 5 equal columns
                        gap: "10px",
                        marginBottom: "20px",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "skyblue",
                        padding: "10px",
                        borderRadius: "10px",
                        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.5)",
                    }}
                >                    {/* Dropdown for Centers */}

                    {/* Multi-select for Centers */}
                    {/* <Select
                            options={centerOptions}
                            isMulti
                            value={filters?.centers}
                            onChange={(selectedOptions) =>
                                setFilters((prev) => ({ ...prev, centers: selectedOptions }))
                            }
                            placeholder="All Centers"
                        /> */}

                    {/* Multi-select for Doctors */}
                    <Select
                        options={doctorsWithId}
                        isMulti
                        value={filters?.doctors}
                        onChange={handleChange}
                        placeholder="All Doctors"
                        closeMenuOnSelect={false} // Keep menu open on selection
                        hideSelectedOptions={false} // Don't hide selected options
                        getOptionLabel={(e) => (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={filters?.doctors?.some(
                                        (doc) => doc.value === e.value
                                    )}
                                    onChange={() =>
                                        handleChange(
                                            filters?.doctors?.some((doc) => doc.value === e.value)
                                                ? filters.doctors.filter((doc) => doc.value !== e.value)
                                                : [...(filters?.doctors || []), e]
                                        )
                                    }
                                    style={{ marginRight: 10, width: "10%" }}
                                />
                                {e.label}
                            </div>
                        )}
                        styles={{
                            option: (provided) => ({
                                ...provided,
                                display: "flex",
                                alignItems: "center",
                            }),
                        }}
                    />
                    {/* Start Date Picker */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            marginLeft: "10px",
                        }}
                    >
                        <label htmlFor="startDate">Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            id="startDate"
                            placeholder="Start Date"
                            value={filters?.startDate}
                            onChange={handleInputChange}
                        />
                    </div>
                    {/* End Date Picker */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            marginLeft: "10px",
                        }}
                    >
                        <label htmlFor="ed">End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            placeholder="End Date"
                            value={filters?.endDate}
                            onChange={handleInputChange}
                        />
                    </div>

                    <img
                        src={searchIcon}
                        alt="excel"
                        title="Search"
                        onClick={fetchData}
                        style={{
                            width: "24px",
                            height: "24px",
                            cursor: "pointer",
                            border: "2px solid #4A90E2", // Border with color
                            borderRadius: "4px", // Optional: rounded corners
                            padding: "2px", // Optional: space between image and border
                        }}
                    />
                </div>
                <div
                    style={{
                        gridColumn: "span 2",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "end",
                        flexGrow: 1,
                        justifyContent: "flex-end", // Align to the right
                    }}
                >
                    <img
                        src={exportIcon}
                        alt="excel"
                        style={{ width: "24px", height: "24px", cursor: "pointer" }}
                        title="Export to Excel"
                        onClick={handleExport}
                    />
                    {/* <button
            onClick={handleExport}
            disabled={isLoading}
            style={{
              maxHeight: "50px",
              backgroundColor: "blue", // Green background
              color: "white", // White text
              padding: "10px 20px", // Padding
              border: "none", // Remove border
              borderRadius: "5px", // Rounded corners
              fontSize: "16px", // Font size
              cursor: "pointer", // Pointer cursor on hover
              transition: "background-color 0.3s ease", // Smooth transition for hover effect
            }}
          >
            {isLoading ? "Exporting..." : "Export to Excel"}
          </button> */}
                    {/* {isLoading && <span>Loading...</span>} */}
                </div>

                {/* Table for Displaying Data */}
                <OpdTables
                    data={data}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    filters={filters}
                />

            </div>
        </>

    );
};

export default OpdPayout;
